import {Analytics} from "./Analytics";
import {UnipageNavigatorAssessmentSource} from "../enums/UnipageNavigatorAssessmentSource";

export class Navigator {
  private static readonly endpoint: string = `${document.location.origin}/api/navigator`;

  public static async answers(
    answers: any,
    analytics: any,
    source: UnipageNavigatorAssessmentSource,
    isUpdate: boolean = false
  ): Promise<any> {
    const uuid = Analytics.instance().getSessionUuid();

    const formData = new FormData();
    formData.append("answers", JSON.stringify(answers));
    formData.append("analytics", JSON.stringify(analytics));
    formData.append("source", source);

    const response = await fetch(`${this.endpoint}/answers?sessionId=${uuid}`, {
      method: isUpdate ? "PATCH" : "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Answers is failed: ${response.statusText}`);
    }

    return await response.json();
  }

  public static async results(results: any, textResults: string, source: UnipageNavigatorAssessmentSource): Promise<any> {
    const uuid = Analytics.instance().getSessionUuid();

    const formData = new FormData();
    formData.append("results", JSON.stringify(results));
    formData.append("textResults", textResults);
    formData.append("source", source);

    const response = await fetch(`${this.endpoint}/results?sessionId=${uuid}`, {
      method: "POST",
      body: formData
    });

    if (!response.ok) {
      throw new Error(`Results is failed: ${response.statusText}`);
    }

    return await response.json();
  }
}